import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listConversations, getConversation, patchConversation, deleteConversation } from "./api";

export const analysisKeys = { all: ["analysis"], one: (id) => ["analysis", id] };

export function useConversationsQuery() {
  return useQuery({ queryKey: analysisKeys.all, queryFn: listConversations });
}

export function useConversationQuery(id) {
  return useQuery({ queryKey: analysisKeys.one(id), queryFn: () => getConversation(id), enabled: !!id });
}

export function usePatchConversationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => patchConversation(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: analysisKeys.all }),
  });
}

export function useDeleteConversationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteConversation(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: analysisKeys.all }),
  });
}
